
import type { ToolReportEntry } from '../../models/domain/tool-report-entry'
import { computed, defineComponent, ref } from 'vue'
import ToolReportingAside from '../../components/insights/tool-reporting/aside.component.vue'
import ToolReportingBarChart from '../../components/insights/tool-reporting/bar-chart.component.vue'
import ToolReportingNoDatesSelected from '../../components/insights/tool-reporting/no-dates-selected.component.vue'
import ToolReportingStats from '../../components/insights/tool-reporting/stats.component.vue'
import ToolReportingTable from '../../components/insights/tool-reporting/table.component.vue'
import ToolReportingToggle, {
  ModesEnum,
} from '../../components/insights/tool-reporting/toggle.component.vue'
import EpbLegend from '../../components/legend.component.vue'
import { useFilters, useToolingReportCtrPerformance } from '../../composables'
import { FeatureIdEnum } from '../../enums/feature-id.enum'

export default defineComponent({
  name: 'ToolReporting',
  components: {
    ToolReportingBarChart,
    ToolReportingTable,
    ToolReportingStats,
    ToolReportingAside,
    ToolReportingNoDatesSelected,
    ToolReportingToggle,
    EpbLegend,
  },
  setup() {
    const { selectedDates } = useFilters()
    const { ctrPerformanceLegendItems } = useToolingReportCtrPerformance()

    const mode = ref()
    const selectedToolReportEntry = ref(null)
    const tool = ref(FeatureIdEnum.PROMOTION)

    const isDateSelected = computed(() => selectedDates.value[0])
    const showTable = computed(() => mode.value === ModesEnum.TABLE)
    const component = computed(() => (showTable.value ? ToolReportingTable : ToolReportingBarChart))

    function selectToolReportEntry(toolReportEntry: ToolReportEntry): void {
      selectedToolReportEntry.value = toolReportEntry
    }

    function unselectToolReportEntry(): void {
      selectedToolReportEntry.value = null
    }

    return {
      baseClass: 'epb-tool-reporting',
      selectToolReportEntry,
      unselectToolReportEntry,
      mode,
      tool,
      isDateSelected,
      selectedToolReportEntry,
      component,
      ctrPerformanceLegendItems,
    }
  },
})
